import CryptoJS from 'crypto-js';

const charSet = [
  ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(97 + i)),
  ...Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i)),
  ...Array.from({ length: 10 }, (_, i) => String.fromCharCode(48 + i)),
  '+', '/'
];

function generateValue() {
    const indices = [7, 45, 33, 9, 17, 51, 37, 40, 54, 5, 0, 62, 34, 44, 51, 56];
    const value = indices.map(index => charSet[index]).join('');
    return value;
}

function generateIV() {
    const indices = [31, 6, 46, 10, 38, 45, 30, 29, 42, 11, 42, 41, 61, 16, 8, 11];
    const iv = indices.map(index => charSet[index]).join('');
    return iv;
}

const value = generateValue(); 
const IV = generateIV();

export const parsedValue = CryptoJS.enc.Utf8.parse(value); 
export const intiVector = CryptoJS.enc.Utf8.parse(IV);

export const encryptHandler = (data) => {
    const preEncrypteds = CryptoJS.AES.encrypt(JSON.stringify(data), parsedValue, {
        iv: intiVector,
        mode: CryptoJS.mode.CBC,
        keySize: 128 / 8,
    });
    const result = preEncrypteds.toString(CryptoJS.format.Hex);
    return result;
};

export const decryptHandler = (data) => {
    const dataHex = CryptoJS?.enc?.Hex?.parse(data);
    const preDecrypted = CryptoJS?.AES?.decrypt(
        { ciphertext: dataHex },
        parsedValue, // Updated variable name
        { iv: intiVector, mode: CryptoJS.mode.CBC, keySize: 128 / 8 }
    );
    const encDecrypted = preDecrypted.toString(CryptoJS.enc.Utf8);
    return encDecrypted;
};
